export default __webpack_public_path__ + "static/107985-9c2d1971d7c0179cbdacf5750fd45d13.jpg";